import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { ValoresRetencao } from "./DisplayRetencao/DialogAdicionar";

export default function InfoStep05() {

    const { getValues } = useFormContext()
    const { step05 } = getValues()
    const possuiRetencao = step05.add_retencoes === 'true'
    const retencoes: ValoresRetencao[] = step05.retencoes

    return (
        <>
            <Box display={'flex'} flexDirection={'column'} >
                {
                    !possuiRetencao &&
                    <Typography variant="subtitle2" color="textSecondary">Não possui retenções</Typography>
                }

                {
                    possuiRetencao &&
                    <>
                        <Typography variant="subtitle2" color="textSecondary">Divisão por retenção</Typography>
                        <Box overflow={'auto'} display={'flex'} maxWidth={500} flexDirection={'column'} flexWrap={'wrap'} gap={0}>
                            {
                                retencoes.filter(item => item.checked).map((item, index) => {
                                    return (
                                        <Box key={index} display="flex" gap={1} my={0.5}>
                                            <Typography variant="subtitle2">
                                                {`${index + 1}º) ${item.retencao?.descricao}`}
                                            </Typography>
                                            <Box
                                                flex={1}
                                                borderBottom="1px dotted black"
                                                sx={{ boxSizing: "border-box", height: '14px' }}
                                            />
                                            <Typography variant="subtitle2">{item.valor}</Typography>
                                        </Box>
                                    )
                                })
                            }
                        </Box>
                    </>
                }
            </Box>
        </>
    )
}